import { useCallback, useLayoutEffect, useState } from 'react';

// Collapse is local to the open conversation, not an Appearance setting.
export default function useSourcesOutputsCollapse(conversationId) {
  const [state, setState] = useState({ conversationId, collapsed: false, gamesExpanded: false });
  useLayoutEffect(() => {
    setState({ conversationId, collapsed: false, gamesExpanded: false });
  }, [conversationId]);
  const update = useCallback((key, value) => {
    setState(current => ({
      ...(current.conversationId === conversationId
        ? current : { conversationId, collapsed: false, gamesExpanded: false }),
      [key]: value,
    }));
  }, [conversationId]);
  const onCollapsedChange = useCallback(value => update('collapsed', value), [update]);
  const onGamesExpandedChange = useCallback(value => update('gamesExpanded', value), [update]);
  return {
    collapsed: state.conversationId === conversationId && state.collapsed,
    gamesExpanded: state.conversationId === conversationId && state.gamesExpanded,
    onCollapsedChange,
    onGamesExpandedChange,
  };
}
